import { useTailgateGridQuery } from '@/graphql/generated/hooks'

interface UseInitialTailgateGridIProps {
  doorId: string
  cameraId: string
  isGridConfigured: boolean
}

export const useInitialTailgateGrid = ({
  doorId,
  cameraId,
  isGridConfigured,
}: UseInitialTailgateGridIProps) => {
  const { data: initialGrid, loading: isInitialGridLoading } =
    useTailgateGridQuery({
      variables: {
        doorId,
        cameraId,
      },
      fetchPolicy: 'network-only',
      skip: !isGridConfigured || !cameraId || !doorId,
    })

  return {
    isInitialGridLoading,
    initialTailgateGrid: initialGrid?.tailgateGrid,
  }
}
